import React, { Component } from "react";
import { Snackbar, SNACKBAR_TYPES } from "../snackbar/Snackbar";
import { Close } from "../icons/deprecated/Close";
import "./ErrorBoundary.scss";
const throttle = (func, throttleTime) => {
    let inThrottle = false;
    return (args) => {
        if (!inThrottle) {
            func(args);
            inThrottle = true;
            setTimeout(() => (inThrottle = false), throttleTime);
        }
    };
};
const throttleByErrorType = (func, throttleTime) => {
    const storedThrottleFunctions = {};
    return (args) => {
        const key = JSON.stringify(args, ["message", "arguments", "type", "name"]);
        if (typeof storedThrottleFunctions[key] === "function") {
            return storedThrottleFunctions[key](args);
        }
        storedThrottleFunctions[key] = throttle(func, throttleTime);
        return storedThrottleFunctions[key](args);
    };
};
const errorsToIgnore = [];
const THROTTLE_TEN_MINUTES = 600000;
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.showError = (event) => {
            if (errorsToIgnore.includes(btoa(JSON.stringify(event, ["message"])))) {
                return;
            }
            this.setState({
                hasError: "LISTENER_ERROR",
            });
        };
        this.throttledShowError = throttleByErrorType(this.showError, THROTTLE_TEN_MINUTES);
        this.state = {
            hasError: false,
        };
    }
    componentDidMount() {
        window.addEventListener("error", this.throttledShowError);
        window.addEventListener("unhandledrejection", this.showError);
    }
    componentWillUnmount() {
        window.removeEventListener("error", this.throttledShowError);
        window.removeEventListener("unhandledrejection", this.showError);
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onCatch) {
            this.props.onCatch(error, errorInfo);
        }
    }
    static getDerivedStateFromError() {
        return { hasError: "RENDER_ERROR" };
    }
    render() {
        const hasRenderError = this.state.hasError === "RENDER_ERROR";
        const willRenderFallback = hasRenderError && this.props.fallback;
        const content = hasRenderError ? this.props.fallback : this.props.children;
        return (React.createElement(React.Fragment, null,
            this.state.hasError && !willRenderFallback && (React.createElement("div", { className: "error-boundary-error" },
                React.createElement(Snackbar, { type: SNACKBAR_TYPES.ERROR, icon: true },
                    React.createElement("div", null,
                        React.createElement("p", null,
                            React.createElement("strong", null, this.props.header)),
                        React.createElement("p", null, this.props.text)),
                    React.createElement("button", { className: "close-error-boundary", onClick: () => this.setState({ hasError: false }) },
                        React.createElement(Close, null))))),
            content));
    }
}
